module.exports = __webpack_public_path__ + "img/news_img_en.6ab6102c.png";